module.exports = __webpack_public_path__ + "static/media/csvformate.2e4d621d.csv";